import request from '@host-panel/request';

type Response = {
  results: { [messageId in string]: boolean };
};

export default function unlockComments(): Promise<Response> {
  return request(`/host-panel/moderation-mode/remove-locks`, {
    method: 'DELETE',
    keepalive: true,
    priority: 'high',
  });
}